const RANK_STYLES: Record<string, string> = {
  warrior: 'bg-zinc-700/60 text-zinc-200',
  elite: 'bg-emerald-700/50 text-emerald-200',
  master: 'bg-sky-700/50 text-sky-200',
  grandmaster: 'bg-indigo-700/50 text-indigo-200',
  epic: 'bg-purple-700/50 text-purple-200',
  legend: 'bg-orange-700/50 text-orange-200',
  mythic: 'bg-rose-700/50 text-rose-200',
  mythical_glory: 'bg-gradient-to-r from-amber-500/60 to-yellow-300/60 text-amber-50',
  mythical_immortal: 'bg-gradient-to-r from-fuchsia-500/60 to-cyan-400/60 text-white',
};

export default function RankBadge({ rankId, label }: { rankId: string; label: string }) {
  const style = RANK_STYLES[rankId] ?? 'bg-zinc-700/60 text-zinc-200';
  return (
    <span className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-medium ${style}`}>
      🏆 {label}
    </span>
  );
}
